import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';

export const STEPS_CONFIG = {
  GENERAL: {
    label: 'General Information',
    key: 'general',
    permissionIds: [AuthorizePermission.APP_GENERAL_INFORMATION_UPDATE],
  },
  DESCRIPTION: {
    label: 'Description',
    key: 'description',
    permissionIds: [AuthorizePermission.APP_DESCRIPTION_UPDATE],
  },
  CONFIGURATION: {
    label: 'Configuration Settings',
    key: 'configuration',
    permissionIds: [AuthorizePermission.APP_CONFIGURATION_UPDATE],
  },
  PRICING: {
    label: 'Pricing',
    key: 'pricing',
    permissionIds: [AuthorizePermission.APP_PRICING_UPDATE, AuthorizePermission.APP_PRICING_UPDATE_KEY_FEATURE, AuthorizePermission.APP_PRICING_READ],
  },
  PERMISSION_CONFIGURATION: {
    label: 'Permission Settings',
    key: 'permission-configuration',
    permissionIds: [AuthorizePermission.APP_CONFIGURATION_UPDATE],
  },
  CONFIRMATION: {
    label: 'Preview & Confirmation',
    key: 'confirmation',
    permissionIds: [],
  },
};
